
import { Vue, Options } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { maska } from 'maska'
import draggable from 'vuedraggable'
import { calcOrderingDragend } from '@/utils/helpers'
import ConditionAnd from '@/components/common/condition-setting/ConditionAnd.vue'
import type { IAudienceBuilderCondition } from '@/utils/types'
import { v4 as uuidv4 } from 'uuid'
@Options({
  components: { draggable, ConditionAnd },
  directives: { maska },
  emits: ['update:modelValue'],
})
export default class ConditionOr extends Vue {
  @Prop({ default: [] })
  modelValue!: IAudienceBuilderCondition[]

  @Prop()
  isDeleteFirst!: boolean

  get value() {
    return this.modelValue
  }

  set value(value: IAudienceBuilderCondition[]) {
    this.$emit('update:modelValue', value)
  }

  @Watch('modelValue', { immediate: true })
  showDefault() {
    if (this.value.length === 0) {
      this.handleAddCondition(0)
    }
  }

  handleAddCondition(index: number): void {
    const newCondition: IAudienceBuilderCondition = {
      _id: uuidv4(),
      conditions: [
        {
          _id: uuidv4(),
          type: '',
          data_id: [],
          column_name: '',
          text: '',
          filter: 'include',
          date: '',
        },
      ],
    }
    if (this.value) {
      this.value.splice(index + 1, 0, newCondition)
    }
  }

  handleDeleteCondition(index: number): void {
    if (this.value) {
      this.value.splice(index, 1)
    }
  }

  // eslint-disable-next-line
  async onDragEnd(evt: any, finalList: IAudienceBuilderCondition[]) {
    if (!evt.moved) {
      return
    }

    const record = evt.moved.element
    calcOrderingDragend(record, finalList)
  }
}
